import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { popupOpenService } from '../../services/popupOpenService';
import { initializeRecipeCreateService, recipeCreateServiceItem } from '../../services/recipeCreateService';
import { Select, Button } from '@chapche/ui';
import {POPUP_KEY_CREATE_RECIPE} from '../../constant';
import { useTranslation } from 'react-i18next';
import { keyDownService } from '../../services/keyDownService';
import { MAIN_RECIPE_ELEMENTS } from '../helper';
import {RecipeType} from "../../services/recipeTypes";

const CreateNewRecipePopup = () => {
    const { i18n } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const [newRecipeCode, setNewRecipeCode] = useState('');
    const navigate = useNavigate();
    const createFullList = () => {
        return Object.values(RecipeType).map((it) => ({
            value: it,
            label: i18n.t(`recipe.item.type.${it}`),
        }));
    };
    const changePopupVisibility = () => {
        setIsVisible(true);
        setNewRecipeCode('');
    };

    useEffect(() => {
        popupOpenService.registerPopup(POPUP_KEY_CREATE_RECIPE, changePopupVisibility);
        initializeRecipeCreateService();
        return () => popupOpenService.unRegisterPopup(POPUP_KEY_CREATE_RECIPE, changePopupVisibility);
    }, []);

    const redirectToEditPage = (response) => {
        navigate(`/recipe/item/${response.id}/?ingredientTab=${MAIN_RECIPE_ELEMENTS}`);
    };

    const createNewItem = () => {
        recipeCreateServiceItem.saveNewItem(redirectToEditPage);
    };

    const changeRecipeCode = (recipeCode) => {
        setNewRecipeCode(recipeCode);
        recipeCreateServiceItem.changeItemCode(recipeCode);
    };

    return (
        isVisible ?
            <>
                <div className="modal__wrapper modal__wrapper_active" onClick={() => setIsVisible(false)}></div>  
                <article className="modal modal_small" onKeyDown={(e) => keyDownService.saveNewItem(e, createNewItem)} tabIndex="0">
                    <h2 className="modal__title block__title-h3">{i18n.t(`app.page.recipe.modal.createRecipe.title`)}</h2>
                    <p className="block__content modal__text product__modal-text">{i18n.t(`app.page.recipe.modal.createRecipe.content`)}</p>
                    <label className={`block__text recipe__form-label recipe__form_lowercase recipe__form-modal ${newRecipeCode ? 'recipe__form-modal_active' : ''}`}>
                        {i18n.t('app.page.recipe.recipeType')}
                        <Select
                            fullWidth
                            className="mt-0"
                            options={createFullList()}
                            value={newRecipeCode}
                            onChange={changeRecipeCode}
                        />
                    </label>
                    <div className="modal__button-group">
                        <Button variant="outline" onClick={() => setIsVisible(false)}>
                            {i18n.t(`app.page.recipe.modal.createRecipe.cancel`)}
                        </Button>
                        <Button disabled={!newRecipeCode} onClick={createNewItem}>
                            {i18n.t(`app.page.recipe.modal.createRecipe.create`)}
                        </Button>
                    </div>
                </article>
            </>
            :
            null
    );
};

export default CreateNewRecipePopup;
